const setCommunityUrlInLocalStorage = locationState => {
  const { from, queryParams } = locationState;
  localStorage.setItem('community-join-url', from + queryParams);
};

export default setCommunityUrlInLocalStorage;
